var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaestro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 30,
    viewBox: "0 0 43 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41.5,
    height: 29,
    rx: 3.5,
    fill: "white",
    stroke: "#B2BCCA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.072 14.6323C24.072 19.2616 20.3622 23.0145 15.786 23.0145C11.2098 23.0145 7.5 19.2616 7.5 14.6323C7.5 10.0029 11.2098 6.25006 15.786 6.25006C20.3622 6.25006 24.072 10.0029 24.072 14.6323Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8215 14.6323C34.8215 19.2616 31.1118 23.0145 26.5355 23.0145C21.9593 23.0145 18.2495 19.2616 18.2495 14.6323C18.2495 10.0029 21.9593 6.25006 26.5355 6.25006C31.1118 6.25006 34.8215 10.0029 34.8215 14.6323Z",
    fill: "#2F80ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1608 8.25243C22.9423 9.78988 24.072 12.0776 24.072 14.6322C24.072 17.1868 22.9423 19.4745 21.1608 21.0119C19.3792 19.4745 18.2495 17.1868 18.2495 14.6322C18.2495 12.0776 19.3792 9.78987 21.1608 8.25243Z",
    fill: "#6C6BBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaestro);
export default __webpack_public_path__ + "static/media/Maestro.724a816e5cfcd06cc14db298d18fc7a8.svg";
export { ForwardRef as ReactComponent };